angular.module('impactx.themeconfigurator').controller('ThemeConfiguratorColorPickerCtrl', [
    'ColorUtilService',
    ThemeConfiguratorColorPickerController]);

function ThemeConfiguratorColorPickerController(ColorUtilService) {
    var self = this;
    self.hasWhiteBackground = true;
    self.identifier = self.label + self.workspaceName;
    self.hex = "";
    self.hsv = {};
    self.rgb = {};
    self.rgbStringInput = 0 + ', ' + 0 + ', ' + 0;
    self.rgbaColor = 'rgba(' + self.rgbStringInput + ', 1)';

    self.setColorValueByRGB = function (rgb, keepCursor) {
        var tmp = rgb.split(',');
        if (impactX.isDefined(tmp, 'length') == 3) {
            var r = tmp[0];
            var g = tmp[1];
            var b = tmp[2];
            updateColorValuesByRGB(r, g, b);
            self.sliderValue = parseInt(self.hsv.hue);
            self.changeColor(null, keepCursor);
        }
    };

    self.setColorValueByHex = function (hex) {
        if (impactX.isDefined(hex, 'length') == 6) {
            updateColorValuesByHex(hex);
            self.changeColor();
        }
    };

    self.setColorBySlider = function (hue) {
        updateColorValuesByHue(hue);
        self.changeColor(null, true);
    };

    self.fillGradient = function () {
        var tmpRGB = ColorUtilService.hsvToRgb(self.hsv.hue, 100, 100);
        self.mainCanvas.fillStyle = 'rgba(' + tmpRGB.r + ', ' + tmpRGB.g + ', ' + tmpRGB.b + ', 1)';
        self.mainCanvas.fillRect(0, 0, self.width, self.height);

        var grdWhite = self.sideCanvas.createLinearGradient(0, 0, self.width, 0);
        grdWhite.addColorStop(0, 'rgba(255,255,255,1)');
        grdWhite.addColorStop(1, 'rgba(255,255,255,0)');
        self.mainCanvas.fillStyle = grdWhite;
        self.mainCanvas.fillRect(0, 0, self.width, self.height);

        var grdBlack = self.sideCanvas.createLinearGradient(0, 0, 0, self.height);
        grdBlack.addColorStop(0, 'rgba(0,0,0,0)');
        grdBlack.addColorStop(1, 'rgba(0,0,0,1)');
        self.mainCanvas.fillStyle = grdBlack;
        self.mainCanvas.fillRect(0, 0, self.width, self.height);
    };

    self.changeColor = function (e, keepCursor) {
        if (e) {
            self.x = e.offsetX;
            self.y = e.offsetY;

            var imageData = self.mainCanvas.getImageData(self.x, self.y, 1, 1).data;
            self.rgb = {
                r: imageData[0],
                g: imageData[1],
                b: imageData[2]
            }
        }
        else {
            self.fillGradient();
        }

        updateColorValuesByRGB(self.rgb.r, self.rgb.g, self.rgb.b);
        updateColoredComponents(keepCursor);
    };

    function updateColoredComponents(keepCursor) {
        if (self.rgb) {
            self.colorLabel2.style.backgroundColor = self.rgbaColor;

            if (self.drag) {
                self.cursor.style.left = (self.x - 10) + 'px';
                self.cursor.style.top = (self.y - 10) + 'px';
            }
            else {
                if (!keepCursor) {
                    var x = (self.width * self.hsv.saturation) / 100;
                    var y = self.height - ((self.height * self.hsv.value) / 100);
                    self.cursor.style.left = (x - 10) + 'px';
                    self.cursor.style.top = (y - 10) + 'px';
                }
            }
            self.cursor.style.background = self.rgbaColor;
            self.colorLabel2.style.backgroundColor = self.rgbaColor;
            var tmpRGB = ColorUtilService.hsvToRgb(self.sliderValue, 100, 100);
            self.subElement.style.background  = 'rgba(' + tmpRGB.r + ', ' + tmpRGB.g + ', ' + tmpRGB.b + ', 1)';


            var luma = 0.2126 * self.rgb.r + 0.7152 * self.rgb.g + 0.0722 * self.rgb.b; // per ITU-R BT.709
            if (luma > 128) {
                self.textHeader.style.color = "#000";
                self.hasWhiteBackground = true;
            }
            else {
                self.textHeader.style.color = "#fff";
                self.hasWhiteBackground = false;
            }
        }
    }

    function updateColorValuesByRGB(r, g, b) {
        if (r >= 0 && g >= 0 && b >= 0) {
            self.rgb = {
                r: r,
                g: g,
                b: b
            };
            self.rgbStringInput = r + ', ' + g + ', ' + b;
            self.rgbaColor = 'rgba(' + r + ', ' + g + ', ' + b + ', 1)';
            self.hex = ColorUtilService.rgbToHex(r, g, b);
            self.hsv = ColorUtilService.rgbToHsv(r, g, b);
            self.colorValue = self.hex;
        }
    }

    function updateColorValuesByHex(hex) {
        if (hex) {
            var rgb = ColorUtilService.hexToRgb(hex);
            updateColorValuesByRGB(rgb.r, rgb.g, rgb.b);
            self.sliderValue = parseInt(self.hsv.hue);
        }
    }

    function updateColorValuesByHue(hue) {
        if (hue) {
            var rgb = ColorUtilService.hsvToRgb(hue, self.hsv.saturation, self.hsv.value);
            updateColorValuesByRGB(rgb.r, rgb.g, rgb.b);
            self.hsv.hue = hue;
            self.sliderValue = parseInt(hue);
        }
    }
}